export default "__VITE_ASSET__CM8Rh8ur__"